import { render, staticRenderFns } from "./priceListAdmin.vue?vue&type=template&id=363d3334&scoped=true"
import script from "./priceListAdmin.vue?vue&type=script&lang=js"
export * from "./priceListAdmin.vue?vue&type=script&lang=js"
import style0 from "./priceListAdmin.vue?vue&type=style&index=0&id=363d3334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d3334",
  null
  
)

export default component.exports